module.exports = __webpack_public_path__ + "static/img/user.9208377a.png";